module.exports = __webpack_public_path__ + "static/media/Visualisation.c33de9a1.mp3";